import { createAsyncAction } from 'typesafe-actions';
import { repositories } from 'api';
import * as types from './types';

export const fetchSimpleProduct = createAsyncAction(
    types.FETCH_SIMPLE_PRODUCT_REQUEST,
    types.FETCH_SIMPLE_PRODUCT_SUCCEEDED,
    types.FETCH_SIMPLE_PRODUCT_FAILED,
)<string, repositories.SimpleProduct, Error>();
